import { IQApp } from "capacitor-garmin-sdk";

// Minimum version of Garmin Connect app required for Bluetooth syncing
export const GARMIN_BT_MIN_VERSION = 0; // Not really needed for scorza

// Garmin full app
export const GARMIN_FULL_APP_INFO: IQApp = {
    uuid: "cbd9a3bd-58c9-4add-9a2e-00ab4ee2a4e8", // Scorza Garmin app
    storeUUID: "fcabde94-66ff-442c-bbc1-de04d0d0837f",
};

// FIXME not required for scorza
export const GARMIN_LITE_APP_INFO: IQApp = {
    uuid: "5d5b8e3c-2fbb-48b6-bb23-bde871897730",
    storeUUID: "91f3257d-b8dd-4ca0-b849-3b4c0fdab7ae",
};

// Garmin Lite app - taken from the Garmin lite page
export const GARMIN_LITE_DEVICES = [
    "ForeAthlete 245",
    "ForeAthlete 55",
    "Forerunner 158",
    "ForeAthlete 645",
    "ForeAthlete 935",
    "Forerunner 245",
    "Forerunner 55",
    "Forerunner 645",
    "Forerunner 935",
    "Venu Sq",
    "fēnix 5",
    "quatix 5",
    "fēnix 5S",
    "fēnix 6",
    "fēnix 6 Dual Power",
    "fēnix 6 Solar",
    "fēnix 6S",
    "fēnix 6S Dual Power",
    "fēnix 6S Solar",
    "fēnix Chronos",
    "vívoactive 3",
];

export const GARMIN_INCOMPATIBLE_DEVICES = [
    "edge", // cycle computers
    "etrex", // handheld GPS
    "gpsmap", // handheld GPS
    "montana", // handheld GPS
    "oregon", // handheld GPS
    "rino", // handheld GPS
    "index", // scales
];

export const PLAY_STORE_CONNECT_URL =
    "https://play.google.com/store/apps/details?id=com.garmin.android.apps.connectmobile";
export const APP_STORE_CONNECT_URL =
    "https://apps.apple.com/app/garmin-connect/id583446403";

export const PLAY_STORE_CONNECT_IQ_URL =
    "https://play.google.com/store/apps/details?id=com.garmin.connectiq";
export const APP_STORE_CONNECT_IQ_URL =
    "https://apps.apple.com/app/garmin-connect-iq/id583722529";
